import { T } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { center, stack } from '@flipster/styled-system/patterns';
import { numberFormatter } from '@flipster/utils/num';

import { useTradingPause } from './state';

interface Props {
  symbol: string;
}

export const TradingPausedLayer = ({ symbol }: Props) => {
  const { pauseDuration = 0, untilPauseEnd = 0 } = useTradingPause(symbol);

  return (
    <div className={center({ pos: 'absolute', inset: 0, zIndex: 800, bg: 'rgba(0, 0, 0, 0.8)' })}>
      <div className={stack({ gap: 12, align: 'center', p: '96px 40px 136px', textAlign: 'center' })}>
        <p className={css({ textStyle: 'Legacy/H5', color: 'legacy.yellow' })}>
          <T id='Assets.r250401.Trading_temporarily_paused' />
        </p>
        <p className={css({ textStyle: 'Legacy/Body2', color: 'legacy.yellow' })}>
          <T id='Assets.r250401.second_sec_remaining' values={{ second: numberFormatter(untilPauseEnd) }} />
        </p>
        <ProgressBar total={pauseDuration} current={pauseDuration - untilPauseEnd + 1} />
        <p className={css({ textStyle: 'Legacy/Body2', color: 'legacy.gray.d' })}>
          <T id='Assets.r250401.Trading_temporarily_paused_dialog_description' />
        </p>
      </div>
    </div>
  );
};

interface ProgressBarProps {
  total: number;
  current: number;
}

const ProgressBar = ({ total, current }: ProgressBarProps) => {
  return (
    <div className={css({ w: '100%', h: 5, bgColor: 'legacy.gray.4', borderRadius: '1rem' })}>
      <div
        className={css({
          maxW: '100%',
          h: '100%',
          bgColor: 'legacy.yellow',
          borderRadius: '1rem',
          transition: 'width 300ms ease-in-out',
        })}
        style={{ width: `${(current / total) * 100}%` }}
      />
    </div>
  );
};
